import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { API_BASE_URL } from '../lib/api';
import { withReturnTo } from '../lib/return-to';
import { Field } from './Field';
import { buttonClass } from './ui/Button';

// Org-handle SSO entry (#475): slug → full-page GET to the per-org BYO-IdP leg.
// The slug rides the PATH, not a query param, so a native GET form can't carry
// it — build the URL and navigate. Native `required`+`pattern` block submit
// (with browser feedback) until the handle is plausible. Own file so the
// <form> is this template's ROOT — happy-dom loses `form.nextSibling`, so a
// form must never have template siblings (#481).

/** `GET /auth/org/:slug/login` target for a validated org handle. */
export function orgSsoLoginUrl(slug: string): string {
  return `${API_BASE_URL}/auth/org/${encodeURIComponent(slug)}/login`;
}

/** Mirrors the API's `SlugSchema` (`org-sso.ts`) — GitHub-login shaped. */
const SLUG_PATTERN = '[A-Za-z0-9-]{1,39}';

export function SsoOrgForm(
  props: { initialOrg?: string | null; returnTo?: string | null } = {},
): JSX.Element {
  const submit = (e: SubmitEvent): void => {
    e.preventDefault();
    const form = e.currentTarget as HTMLFormElement;
    const input = form.elements.namedItem('org') as HTMLInputElement;
    window.location.assign(withReturnTo(orgSsoLoginUrl(input.value.trim()), props.returnTo));
  };

  return (
    <form class="sso-login-form" onSubmit={submit}>
      <Field label={t('login.sso_org_label')} id="sso-org">
        {(a11y) => (
          <input
            {...a11y}
            class="input"
            name="org"
            required
            pattern={SLUG_PATTERN}
            placeholder={t('login.sso_org_placeholder')}
            autocomplete="organization"
            value={props.initialOrg ?? ''}
          />
        )}
      </Field>
      <button type="submit" class={buttonClass()}>
        {t('login.sso_org_cta')}
      </button>
    </form>
  );
}
